<template>
  <div class="privacy content">
    <h1>{{ $t('pages.privacy.headline') }}</h1>
    <p>{{ $t('pages.privacy.text-1') }}</p>

    <p>{{ $t('pages.privacy.controller') }}<br>
    epicenter.works - Platform Grundrechtspolitik, ZVR: 140062668<br>
    Widerhofergasse 8/2/4<br>
    1090 Wien<br>
    {{ $t('components.footer.austria') }}
    <a href="mailto:office@epicenter.works">office@epicenter.works</a></p>

    <p>{{ $t('pages.privacy.data-protection-officer') }} <a href="mailto:dsba@epicenter.works">dsba@epicenter.works</a></p>

    <p>{{ $t('pages.privacy.text-2') }} <a href="mailto:office@epicenter.works">office@epicenter.works</a>. {{ $t('pages.privacy.text-3') }} (<a href="https://www.dsb.gv.at/">https://www.dsb.gv.at</a>).</p>

    <p>{{ $t('pages.privacy.text-4') }} <a href="https://www.twilio.com/legal/privacy">{{ $t('pages.privacy.twilio-privacy-policy') }}</a> {{ $t('pages.privacy.text-5') }}</p>

    <p>{{ $t('pages.privacy.text-6') }}</p>

    <p>{{ $t('pages.privacy.text-7') }}</p>

    <p>{{ $t('pages.privacy.text-8') }} <a href="https://de.wikipedia.org/wiki/GNU_Mailman">GNU Mailman</a>{{ $t('pages.privacy.text-9') }} (<a href="https://lists.akvorrat.at/listinfo/vds-info">DE</a>, <a href="https://lists.akvorrat.at/listinfo/newsletter-en">EN</a>) {{ $t('pages.privacy.text-10') }}</p>

    <p>{{ $t('pages.privacy.text-11') }} <a href="https://matomo.org/">Matomo</a>{{ $t('pages.privacy.text-12') }} <a href="https://www.eff.org/issues/do-not-track">Do-Not-Track</a> {{ $t('pages.privacy.text-13') }}</p>

    <p>{{ $t('pages.privacy.text-14') }}</p>

  </div>
</template>

<script>
export default {
  name: 'privacy',
}
</script>
